<template>
  <div>
    <section
      id="description"
      class="component-ebbdd2bb custom-margin"
      resmed-component-name="product_hero_ratings_text_2cta_gallery"
      v-bind:style="{
        'background-image': `url(${acf.layout['background-image']})`,
        'background-color': `${acf.layout['background-color']}`,
        'background-size': `${acf.layout['background-size']}`,
      }"
    >
      <div class="breadcrumbs">
        <productsBreadcrumb
          v-bind:title="acf['product-name']"
          v-bind:pageType="`product_detail`"
        ></productsBreadcrumb>
      </div>
      <tabComponent></tabComponent>
      <div class="component">
        <div class="container">
          <div class="row mx-0">
            <div class="col-md-6 col-lg-5 order-2 order-md-1 mt-3 mt-md-0">
              <div class="product-information">
                <h2 class="heading-lg d-none d-md-block" v-html="acf['product-name']"></h2>
                <div
                  v-if="acf.notinuse && acf.notinuse.includes('notinuse')"
                  class="d-none d-md-block"
                >
                  <p class="discontinued">
                    <img src="@/assets/images/discontinued-color-icon.svg" />
                    {{ $getTranslation("DISCONTINUED", $route.params.region) }}
                  </p>
                </div>
                <p
                  v-if="(show || isResmedUser) && acf.discontinued_description"
                  class="disconote d-none d-md-flex mt-3"
                >
                  <img
                    src="@/assets/images/info-icon.svg"
                    class="mr-2"
                    style="height:16px"
                  /><span v-html="acf.discontinued_description"></span>
                </p>

                <div class="labels">
                  <ul>
                    <li v-for="item in acf.labels">
                      <strong>{{ item.name }}</strong>
                    </li>
                  </ul>
                </div>
                <div v-if="acf.rating && acf.reviews" class="rating-reviews">
                  <a
                    href="#"
                    v-on:click.prevent="
                      scroll({
                        to: `[resmed-component-name='product_ratings_and_reviews']`,
                      })
                    "
                  >
                    <span v-bind:rating="acf.rating"></span
                    >{{ acf.reviews }} Reviews
                  </a>
                </div>
                <div class="mb-4" v-html="acf.description"></div>
                <div v-if="acf.price" class="suggested-retail-price mb-4">
                  <p>
                    <span>${{ acf.price }}</span> suggested retail price
                    <span v-if="acf['price-citation']" class="citation"
                      ><sup>{{ acf["price-citation"] }}</sup></span
                    >
                  </p>
                </div>
                <table
                  class="dark-table w-100 product-code my-5"
                  v-if="acf.product_code.items"
                >
                  <thead>
                    <tr>
                      <th>{{ acf.product_code.item_heading }}</th>
                      <th>{{ acf.product_code.code_heading }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(product, key) in acf.product_code.items"
                      class="text-center"
                    >
                      <td>{{ product.item }}</td>
                      <td>{{ product.code }}</td>
                    </tr>
                  </tbody>
                </table>

                <a
                  v-for="(item, index) in acf.cta"
                  v-if="
                    !getDocumentHref(item.cta.href) &&
                      item.cta.text !== 'Documents'
                  "
                  v-bind:target="item.cta.target"
                  v-bind:href="item.cta.href"
                  class="btn cta-pill icon right-arrow mr-2 ctaButtonDark"
                  :class="item.cta.class"
                  v-on:click.prevent="
                    scroll({
                      to: `${item.cta.href}`,
                    })
                  "
                  >{{ item.cta.text }}</a
                >
                <a
                  v-for="(item, index) in acf.cta"
                  v-if="getDocumentHref(item.cta.href)"
                  v-bind:href="item.cta.href"
                  v-bind:target="item.cta.target"
                  class="btn cta-pill icon right-arrow hallow-red mr-2"
                  :class="item.cta.class"
                  >{{ item.cta.text }}</a
                >
              </div>
            </div>
            <div
              class="
                col-md-6 col-lg-6
                offset-lg-1
                order-1 order-md-2
                mt-3 mt-md-0
              "
            >
              <h2
                v-html="acf['product-name']"
                class="d-block d-md-none mb-3"
              ></h2>
              <div
                v-if="acf.notinuse && acf.notinuse.includes('notinuse')"
                class="d-block d-md-none mb-3"
              >
                <p class="discontinued">
                  <img src="@/assets/images/discontinued-color-icon.svg" />
                  {{ $getTranslation("DISCONTINUED", $route.params.region) }}
                </p>
              </div>
              <p
                v-if="(show || isResmedUser) && acf.discontinued_description"
                class="disconote d-flex d-md-none"
              >
                <img
                  src="@/assets/images/info-icon.svg"
                  class="mr-2"
                  style="height:16px"
                /><span v-html="acf.discontinued_description"></span>
              </p>
             
              <!-- Video (Aprimo / HTML5 native video) or Image stage -->
              <figure class="embed-responsive embed-responsive-997by720 stage">
                <template v-if="active.video">
                  <video
                    ref="videoPlayer"
                    class="embed-responsive-item video-js vjs-default-skin"
                    controls
                    preload="auto"
                    v-bind:poster="active.aprimoThumbnail"
                    style="width:100%;height:100%;position:absolute;top:0;left:0"
                  ></video>
                </template>
                <img
                  v-else
                  class="img-fluid embed-responsive-item"
                  v-bind:src="active.src"
                  v-bind:alt="active.alt"
                />
              </figure>

              <ul class="thumbnails">
                <li
                  v-for="(item, key) in acf.gallery"
                  v-bind:key="item.id"
                  v-bind:class="{ 'is-active': active.id === item.id }"
                  v-on:click.prevent="gallery(item)"
                >
                  <figure>
                    <img
                      class="img-fluid"
                      v-bind:src="item.aprimo_url ? item.aprimo_thumbnail : item.sizes.medium"
                      v-bind:alt="item.alt"
                    />
                  </figure>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="(show || isResmedUser) && spareParts.length"
            class="row p-3"
            style="background-color: #2086D0; margin: 0 10px;"
          >
            <p
              class="text-white"
              style="font: 600 16px 'cern-medium';"
            >
              Spare Parts ({{ spareParts.length }}
              {{ spareParts.length > 1 ? "items" : "item" }})
            </p>
          </div>
          <div class="sparepartbg" v-if="(show  || isResmedUser) && spareParts.length">
            <div class="row">
              <div
                class="col-12 col-md-3"
                v-for="(item, index) of sparePartsUpdated"
                :key="index"
              >
                <div class="spares">
                  <div class="card cardswidth" @click="showSparePart(item)">
                    <div
                      class="img-spareparts"
                      :style="{
                        background: `url(&quot;${
                          item._source.images[0]
                        }&quot;)`,
                      }"
                    ></div>
                    <div class="card-block">
                      <span style="font: 12px 'cern-light'; color: #757070;"
                        >Part Number</span
                      >
                      <h4
                        style="font: 600 16px 'cern-bold';"
                        class="card-title itemnumbercls my-1"
                      >
                        {{ item._source.item_no }}
                      </h4>
                      <p
                        style="font: 14px 'cern-medium'; color: #757070"
                        class="card-text"
                      >
                        {{ item._source.spare_part_name }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="spareParts.length > 4">
            <button class="buttonarea" @click="toggle">
              {{ sparePartsUpdated.length > 4 ? "View Less" : "View More" }}
            </button>
          </div>
        </div>
        <div>
          <vue-final-modal
            v-model="showPopup"
            @click-outside="closemodal"
            class="modal"
          >
            <div class="modal-wrapper">
              <div class="container vh-100 d-flex">
                <div class="bg-light popupalign rounded">
                  <div style="background: #ffffff;">
                    <img
                      :src="sparePartPopup.images && sparePartPopup.images[0]"
                      style="height: 300px; margin: auto;"
                      alt=""
                    />
                  </div>
                  <div class="d-flex justify-content-between align-items-end mt-3">
                    <div>
                      <span style="font: 12px 'cern-light'; color: #757070;"
                        >Part Number</span
                      >
                      <h4
                        style="font: 600 16px 'cern-bold';"
                        class="card-title itemnumbercls my-1"
                      >
                        {{ sparePartPopup.item_no }}
                      </h4>
                      <p
                        style="font: 14px 'cern-medium'; color: #757070"
                        class="card-text"
                      >
                        {{ sparePartPopup.spare_part_name }}
                      </p>
                    </div>
                    <div>
                      <button class="btn closebtn" @click.prevent="closemodal">
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-final-modal>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { scroll } from "../../mixins/index";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "@videojs/http-streaming";

const active = {
  id: "",
  src: "",
  alt: "",
  video: false,
  aprimo_url: "",
  aprimoThumbnail: "",
};

export default {
  name: "component-ebbdd2bb", // product_hero_ratings_text_2cta_gallery
  props: ["acf"],
  data() {
    return {
      active: active,
      siteRegion: "en-us",
      playerInstance: null,
      showImgModal: true,
      sparePartPopup: {},
      showPopup: false,
      spareParts: this.acf.spares || [],
      sparePartsUpdated: [],
    };
  },
  mixins: [scroll],
  methods: {
    ...mapMutations(["setShowLinks"]),
    initializeOrUpdatePlayer() {
      if (!this.$refs.videoPlayer || !this.active.aprimo_url) return;

      if (!this.playerInstance) {
        this.playerInstance = videojs(this.$refs.videoPlayer, {
          controls: true,
          autoplay: false,
          preload: "auto",
          fluid: true,
        });
      }

      this.playerInstance.poster(this.active.aprimoThumbnail || "");
      this.playerInstance.src({
        src: this.active.aprimo_url,
        type: "application/x-mpegURL",
      });
    },
    disposePlayer() {
      if (this.playerInstance) {
        this.playerInstance.dispose();
        this.playerInstance = null;
      }
    },
    gallery(item) {
      this.active = Object.assign({}, active); // reset
      this.active.id = item.id;
      this.active.alt = item.alt;

      if (item.aprimo_url) {
        // Aprimo HLS video
        this.active.video = true;
        this.active.aprimo_url = item.aprimo_url;
        this.active.aprimoThumbnail = item.aprimo_thumbnail || "";
      } else {
        // image
        this.disposePlayer();
        this.active.src = item.sizes.large;
      }
    },
    getDocumentHref(url) {
      if (
        url.startsWith("http:") ||
        url.startsWith("https:") ||
        url.startsWith("www")
      ) {
        return true;
      } else {
        return false;
      }
    },
    toggle() {
      if (this.sparePartsUpdated.length > 4) {
        this.sparePartsUpdated = this.spareParts.slice(0, 4);
        window.scrollTo(0, 400);
      } else {
        this.sparePartsUpdated = this.spareParts;
      }
    },
    showSparePart(item) {
      this.sparePartPopup = item._source;
      this.showPopup = true;
    },
    closemodal() {
      this.showPopup = false;
    },
    isUk() {
      this.siteRegion = this.$route.params.region;
      return this.siteRegion;
    },
  },
  watch: {
    'active.aprimo_url'(newUrl) {
      if (newUrl) {
        this.$nextTick(() => {
          this.initializeOrUpdatePlayer();
        });
      }
    },
  },
  mounted() {
    this.isUk();
    window.onhashchange = () => {
      let hash = window.location.hash.substring(1);

      // explore payment plans cta button
      if (hash === "explore-payment-plans") {
        this.scroll({
          to: '[resmed-component-name="xxx"]',
        });
      }
    };
    this.sparePartsUpdated = this.spareParts.slice(0, 4);
  },
  created() {
    // To show navlinks in the Top bar
    this.setShowLinks(true);

    bus.$emit("navigation:reversed", true);

    this.active.id = this.acf.gallery[0].id;
    this.gallery(this.acf.gallery[0]);
  },
  beforeDestroy() {
    this.disposePlayer();
  },
  computed: {
    isResmedUser() {
      const email = this.$cookies.get("rocEmail");
      if (email && email.toLowerCase().includes("@resmed.")) {
        return true;
      }
      return false;
    },
    show() {
      const role = this.$cookies.get("role");
      const b2bFirstName = this.$cookies.get("b2bFirstName");

      const roles = (role && role.split(",").map((r) => r.trim())) || [];
      const hasAnyTechnicalRole = roles.some(
        (r) =>
          r.includes("sleep_approved") ||
          r.includes("ventilator_approved") ||
          r.includes("oxygen_approved")
      );

      if (hasAnyTechnicalRole && b2bFirstName) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
.custom-margin {
  @media (max-width: 992px) {
    margin-top: 100px;
  }
  @media only screen and (width: 768px) {
    margin-top: 90px;
  }
}
.component-ebbdd2bb {
  background-repeat: no-repeat;
  background-position: center top;
  padding: 5rem 0;

  @media (max-width: 767px) {
    padding: 5rem 0;
    margin-top: 45px;
  }

  @media (min-width: 992px) {
    padding: 9rem 0 5rem 0;
    margin-left: 1.5rem;
  }

  @media (min-width: 992px) {
    padding: 12rem 0 6rem 0;
  }
  .breadcrumbs {
    margin-top: -5rem;
    @media (min-width: 992px) {
      padding-bottom: 2rem;
    }

    @media (min-width: 992px) {
      margin-left: 1.5rem;
    }
  }
}

.component {
  h2 {
    position: relative;
    margin: 0 0 1rem 0;
  }

  .product-information {
    margin-bottom: 3rem;

    @media (min-width: 768px) {
      margin-bottom: 0;
    }

    .btn:not(:last-child) {
      margin-bottom: 0.75rem;
    }

    .product-code {
      border: none;
      border-collapse: collapse;
      thead {
        background-color: #3a3a3a;
        color: white;
        border-spacing: 0;
        th {
          padding: 0.75rem;
        }
      }
      tbody {
        tr:nth-child(odd) {
          background-color: #f4f4f4;
        }
        tr:nth-child(even) {
          background-color: #fdfdfd;
        }
        td {
          border: none;
          padding: 0.75rem;
        }
      }
    }
  }

  .labels {
    margin-bottom: 1.5rem;

    ul {
      list-style: none;
      display: flex;
      flex-wrap: wrap;

      li {
        position: relative;
        margin: 0 1.5rem 0 0;
        white-space: nowrap;

        @extend %body-small;

        @media (max-width: 767px) {
          font-size: 1rem;
        }

        &:first-child {
          margin-left: 0;
        }

        &:not(:last-child) {
          &:before {
            content: "";
            width: 2px;
            height: 12px;
            background-color: $cc-resmed-black;
            position: absolute;
            right: -0.825rem;
            top: 3px;
          }
        }
      }
    }
  }

  .rating-reviews {
    display: flex;
    margin-top: -0.75rem;
    margin-bottom: 1.25rem;

    a {
      display: inherit;
      color: inherit;
      transition: all 0.5s;

      &:hover {
        color: $cc-resmed-hero-blue;

        span {
          opacity: 0.6;
        }
      }
    }

    span {
      display: block;
      width: 120px;
      height: 20px;
      margin-right: 0.625rem;
      transition: all 0.5s;

      background-image: url(#{$assets}/images/star-ratings-blue-0.svg);
      background-position: left center;
      background-repeat: no-repeat;
      background-size: 120px;

      @for $i from 0 through 5 {
        &[rating="#{$i}"] {
          background-image: url(#{$assets}/images/star-ratings-blue-#{$i}.svg);
        }
      }
    }
  }

  .suggested-retail-price {
    border-top: 1px solid rgba($cc-resmed-dark-grey, 0.325);
    border-bottom: 1px solid rgba($cc-resmed-dark-grey, 0.325);
    padding: 0.875rem 0;

    span {
      font-size: 1.125rem;
    }
  }

  figure {
    overflow: hidden;
    border-radius: 6px;
    .embed-responsive-item {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      border: 0;
      margin-left: auto;
      margin-right: auto;
      width: auto;
    }
  }

  .stage {
    background-color: $cc-resmed-white;
    box-shadow: -3px 0.75rem 18px 0 rgba(0, 0, 0, 0.125);
  }

  .thumbnails {
    list-style: none;
    display: flex;
    padding: 1.5rem 0.75rem 0 0.75rem;
    @media (min-width: 768px) {
      padding: 1.5rem 2rem 0 2rem;
    }
    @media (min-width: 992px) {
      padding: 1.5rem 3rem 0 3rem;
    }
    li {
      cursor: pointer;
      margin: 0 0.75rem;
      flex: 1 1 0%;
      max-width: 5rem;
      background: #fff;
      border-radius: 6px;
      img {
        height: 3rem;
        margin: 0 auto;
      }
      @media (min-width: 768px) {
        max-width: 4rem;
      }
      @media (min-width: 992px) {
        max-width: 6rem;
      }
      @media (min-width: 1200px) {
        max-width: 5rem;
      }
      figure {
        border: 2px solid transparent;
      }
      &.is-active {
        figure {
          border: 2px solid $cc-resmed-action-red;
        }
      }
    }
  }
}

.discontinued {
  border: 2px solid #0D0A15;
  color: #0D0A15;
  padding: 2px 9px;
  border-radius: 50px;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  width: fit-content;
}

.disconote {
  padding: 10px;
  border: none;
  font-size: 12px;
  background: #e8f0fe;
  border-radius: 5px;
  color: #222;
}

.icolor {
  color: blue !important;
}

a.btn.icon.right-arrow.primary_btn {
  background-image: url("#{$assets}/images/arrow-white-icon.svg");
  background-color: #0D0A15 !important;
  background-size: 0.63rem 0.63rem !important;
  background-repeat: no-repeat !important;
  background-position: calc(100% - 1.25rem) 50%;
  color: #ffffff !important;
  transition: background 0.2s ease-out;
  border: 2px solid #ffffff !important;
  &:hover {
    background-image: url("#{$assets}/images/icon-right-arrow-black.svg") !important;
    background-color: #E7E7E8 !important;
    background-size: 0.63rem 0.63rem !important;
    background-repeat: no-repeat !important;
    background-position: calc(100% - 1.25rem) center;
    color: #0D0A15 !important;
    border: 2px solid #FFFFFF !important;
    box-shadow: none;
  }
}
</style>